var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#E65C6C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.1 28H39.9C33.3278 28 28 33.3278 28 39.9V56.12C28 62.6922 33.3278 68.02 39.9 68.02H56.1C62.6722 68.02 68 62.6922 68 56.12V39.9C68 33.3278 62.6722 28 56.1 28Z",
    fill: "url(#paint0_linear_748_7150)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9996 45.6599C37.6319 45.6551 37.2778 45.5205 36.9996 45.2799L34.3196 42.8599C34.0142 42.5838 33.8287 42.1993 33.8026 41.7884C33.7764 41.3775 33.9117 40.9726 34.1796 40.6599C34.3085 40.5039 34.4675 40.3755 34.6473 40.2826C34.827 40.1896 35.0237 40.134 35.2255 40.1191C35.4273 40.1041 35.63 40.1302 35.8215 40.1956C36.013 40.2611 36.1892 40.3646 36.3396 40.4999L37.7196 41.7199L40.1596 37.7199C40.2641 37.5458 40.4024 37.3944 40.5663 37.2746C40.7302 37.1549 40.9165 37.0691 41.1141 37.0225C41.3117 36.9759 41.5167 36.9694 41.7168 37.0033C41.917 37.0372 42.1084 37.1108 42.2796 37.2199C42.6186 37.452 42.8567 37.8042 42.9458 38.2052C43.035 38.6062 42.9684 39.0261 42.7596 39.3799L39.3596 44.8599C39.2473 45.0551 39.0914 45.2216 38.904 45.3465C38.7167 45.4714 38.503 45.5513 38.2796 45.5799L37.9996 45.6599ZM61.4396 42.5199C61.4456 42.1248 61.2994 41.7425 61.0314 41.4521C60.7634 41.1618 60.394 40.9855 59.9996 40.9599H47.9996C47.6559 41.0393 47.3493 41.2328 47.1297 41.5088C46.9102 41.7849 46.7906 42.1272 46.7906 42.4799C46.7906 42.8326 46.9102 43.175 47.1297 43.451C47.3493 43.7271 47.6559 43.9206 47.9996 43.9999H59.9996C60.3803 43.9754 60.7384 43.8105 61.0044 43.537C61.2705 43.2636 61.4256 42.9012 61.4396 42.5199ZM38.2196 56.5199C38.4257 56.5121 38.628 56.462 38.8138 56.3725C38.9997 56.283 39.165 56.1562 39.2996 55.9999L42.6996 50.4999C42.9133 50.1474 42.9826 49.726 42.8932 49.3236C42.8038 48.9212 42.5625 48.5688 42.2196 48.3399C42.0484 48.2308 41.857 48.1572 41.6568 48.1233C41.4567 48.0894 41.2517 48.0959 41.0541 48.1425C40.8565 48.1891 40.6702 48.2749 40.5063 48.3946C40.3424 48.5144 40.2041 48.6658 40.0996 48.8399L37.6596 52.8399L36.2796 51.6199C36.1292 51.4846 35.953 51.3811 35.7615 51.3156C35.57 51.2502 35.3673 51.2241 35.1655 51.2391C34.9637 51.254 34.767 51.3096 34.5873 51.4026C34.4075 51.4955 34.2485 51.6239 34.1196 51.7799C33.8565 52.0946 33.7242 52.4984 33.7503 52.9079C33.7764 53.3173 33.9587 53.7011 34.2596 53.9799L36.9996 56.2599C37.2778 56.5005 37.6319 56.6351 37.9996 56.6399L38.2196 56.5199ZM61.4996 53.3999C61.4653 53.023 61.2934 52.672 61.0167 52.4137C60.7401 52.1555 60.378 52.0082 59.9996 51.9999H47.9996C47.5859 51.9999 47.1891 52.1643 46.8965 52.4568C46.604 52.7494 46.4396 53.1462 46.4396 53.5599C46.4396 53.9737 46.604 54.3704 46.8965 54.663C47.1891 54.9556 47.5859 55.1199 47.9996 55.1199H59.9996C60.2054 55.1149 60.408 55.0686 60.5956 54.9839C60.7832 54.8992 60.9519 54.7777 61.0917 54.6267C61.2316 54.4756 61.3397 54.2981 61.4098 54.1046C61.4798 53.9111 61.5104 53.7055 61.4996 53.4999V53.3999Z",
    fill: "url(#paint1_linear_748_7150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_748_7150",
    x1: 28,
    y1: 48.01,
    x2: 68,
    y2: 48.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_748_7150",
    x1: 33.7471,
    y1: 46.8109,
    x2: 61.5017,
    y2: 46.8109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.4c12d789b77f5acc85fd39c96117d9b4.svg";
export { ForwardRef as ReactComponent };